import { render, staticRenderFns } from "./NamadUser.vue?vue&type=template&id=a6a36e82"
import script from "./NamadUser.vue?vue&type=script&lang=js"
export * from "./NamadUser.vue?vue&type=script&lang=js"
import style0 from "./NamadUser.vue?vue&type=style&index=0&id=a6a36e82&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports